import { filter } from 'rxjs';
import { Component, ViewChild, HostListener, ElementRef } from '@angular/core';
import { FormControl, NgForm } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { AppointmentService } from '../../services/appointment.service';
import { ModalDismissReasons, NgbModal, NgbModalRef  } from '@ng-bootstrap/ng-bootstrap';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { merge, startWith, switchMap, catchError, map, BehaviorSubject, Subject } from 'rxjs';
import { Router } from '@angular/router';
import * as XLSX from 'xlsx';
import moment from 'moment';
@Component({
  selector: 'app-appointment',
  templateUrl: './appointment.component.html',
  styleUrls: ['./appointment.component.scss']
})
export class AppointmentComponent {
  @ViewChild('scrollContainer') scrollContainer!: ElementRef; isMobileView = window.innerWidth <= 1024;
  @ViewChild('content') contentTemplate: any;
  scrollThumbWidth = 10;
  scrollThumbLeft = 0;
  mobileInfoVisible : any;
  initialLoad: boolean = true;
  isDataLoading: boolean = true;
  private updateModalRef: NgbModalRef | null = null;
  private removeModalRef: NgbModalRef | null = null;
  UpdateBtnLoading = false;
  removBtnLoading = false;
  showUpdateBtn = false;
  isLoading = false;
  btnLoading = false;
  btnClose = false;
  topBarTitle:string = "Appointments";
  totalRows = 0;
  pageSize = 25;
  currentPage = 0;
  pageSizeOptions: number[] = [25, 50, 100];
  dataSource: MatTableDataSource<any> = new MatTableDataSource();
  @ViewChild(MatPaginator)
  paginator!: MatPaginator;
  appointment:Appointment =  new Appointment();
  @ViewChild(MatSort)
  sort!: MatSort;
  searchQuery = new FormControl();
  isSubmittedresCheduled:boolean = false;
  dateQuery = new FormControl();
  formAction = "add";
	closeResult = '';
  DateList:any = [];
  TimeList:any = [];
  current_id_hover:any;
  paymentDetail:any = {
    payment_status:"",
    remarks:"",
    service:"",
    pincode:"",
  }
  @ViewChild("reappointmentForm")
  reappointmentForm!: NgForm;
  isSubmitted: boolean = false;
  exportArrayData:any = [];
  isOnlinePayment:boolean = false;
  isHospitalWise: boolean = false;
  showOpdFeature: boolean = false;
  displayedColumns: string[] = ["pId","info","name","date","check_in_type","type","source","payment","status","action"];
  exportColumns:any = [];
  topPosition: any;
  leftPosition: any;
  hoveredRow: any;
  departmentListDp:any = []
  DoctorDpList:any = []
  selectedItem:any;
  filtersObject:any = {};
  timeZone:any = Intl.DateTimeFormat().resolvedOptions().timeZone || "Asia/Calcutta";
  app_count:any =  {
  all:null,
  today:null,
  tomorrow:null,
  week:null,
  month:null
  }
  allowedTypes = [
    "walk_in",
    "emergency",
    "",
    "new_adult",
    "new_child",
    "follow_up_adult",
    "follow_up_child",
    "rop",
    "postop"
  ];
  selected_tab:any = "all"
  statusFilter$ = new BehaviorSubject<string>('');
  selectedStatus: string = '';
  overbookedSlotsList: any[] = [];
  isFilteringOverbooked = false;
  reminderFollowUp: boolean = false;
  reminderUpcoming: boolean = false;
  reminderSending: boolean = false;
  overviewStats: any = {
    total: 0,
    in_progress: 0,
    waiting: 0,
    upcoming: 0,
    completed: 0,
    avg_duration: 15,
    overbooked: 0,
    no_shows: 0,
    no_shows_percentage: 0
  };
  overviewStatsSubject = new Subject<any>();
  constructor(private router:Router, private toast:ToastrService, private api:AppointmentService,private modalService: NgbModal, private localStorage:LocalStorageService){
    this.isHospitalWise = this.localStorage.getHospitalWise() == "true";
    this.showOpdFeature = this.localStorage.checkFeatures('opd');
  }

  ngOnInit() {
    this.overviewStatsSubject.pipe(
      switchMap(param => this.api.getAppointmentOverviewStats(param))
    ).subscribe({
      next: (response: any) => {
        if (response && response.stats) {
          this.overviewStats = response.stats;
          this.overbookedSlotsList = response.overbookedList || [];
        }
      },
      error: (err) => {
        console.error('Error fetching overview stats:', err);
      }
    });
  }
  ngAfterViewInit() {
    console.log("tabl column : ",this.displayedColumns);
    this.loadData();
    this.updateScrollThumb();
    setTimeout(() => this.updateScrollThumb(), 100);
    //this.loadDepartments()
    
  }
  showFilterData(event:any){
   if(event){
    this.loadDepartments()
    this.loadDoctorsByDepartments()
   }
  }
  formatTo12Hour(time: string): string {
    if(this.localStorage.isTwelveHourFormat()) {
      return moment(time, 'HH:mm').format('hh:mm A');
    }
    else {
      return time;
    }
    
  }
  loadDepartments()
  {
    let param = {
      where:{
        hospital_id:this.localStorage.getHospitalId(),
        // center_id:this.localStorage.getCenterId(),
        isPublic:true,
      }
      
    }

   this.api.getDepartments(param).subscribe({
    next:(response)=>{
     // console.log(response)
     if(response && response.length > 0){
      this.departmentListDp = response
           
     }
    
    },
    error:(e)=>{

    }
   })
  }
  loadDoctorsByDepartments()
  {
  
    let param = {
        hospital_id:this.localStorage.getHospitalId(),
        center_id:this.localStorage.getCenterId(),
        // dept_id:dept_id,
    }
    if(this.localStorage.getIgnoreCenterCheck()=="true"){
      delete param.center_id;
    }
    this.api.getUserByDepartmentSchedule(param).subscribe({
      next:(response)=>{
       console.log(response)
        this.DoctorDpList = response
      
      },
      error:(e)=>{

      }
     })
  }
  showInfo(row:any,event:any)
  {
    this.hoveredRow = row;
    this.topPosition =  event.clientY;
    this.leftPosition = event.clientX;
    this.current_id_hover = row.appointment.app_id
  }
  onMouseMove(row:any,event: MouseEvent): void {
    this.current_id_hover =  row.appointment.app_id;
  }
  openDialog(element:any)
  {

  }
  hideInfo()
  {
    this.current_id_hover = "";
    this.mobileInfoVisible = null;
  }
  view(item:any)
  {
    localStorage.setItem('pId', item.pId);
    const serialized = this.router.serializeUrl(
      this.router.createUrlTree(['main/appointments/record', item.id, item.appointment.app_id])
    );
    window.open(window.location.pathname + '#' + serialized, '_blank');
  }
  refundPaymentFees(model:any,item:any){
    this.modalService.open(model,  { windowClass:'modal modal-huge', scrollable: false,ariaLabelledBy: 'modal-basic-title', centered: true });
    this.selectedItem = item;
  }
  confirmRefund(){
  
    this.btnLoading = true;
    console.log()
    let param = {
      patient_id:this.selectedItem .appointment.patient_id,
      app_id:this.selectedItem .appointment.app_id,
      hospital_id:this.localStorage.getHospitalId(),
      status:"cancelled",
    }
    this.api.refundAppointmentFees(param).subscribe({
      next:(res)=>{
        this.modalService.dismissAll();
        this.toast.success("Refund initiate successfully")
        this.loadData()
      },
      
      error:(e)=>{
        console.log(e)
        this.toast.error("There is an error from the payment gateway provider for the refund API.")
      }
    })
  }
  checkInOPD(item:any)
  {
    console.log("items : ",item);
    if(item.pId=='N/A' || item.appointment.opd_number=='N/A' || item.appointment.opd_number==null  )
    {
     
      let param = {
        hospital_id:this.localStorage.getHospitalId(),
        center_id:this.localStorage.getCenterId(),
        patient_id:item.id,
        app_id:item.appointment.app_id,
        pId:item.pId,
        opd_number:item.appointment.opd_number,
        payment_amount: item.appointment.payment_amount,
        payment_status: item.appointment.payment_status,
        details: item.appointment.details,
        status:"check_in",
      }
     this.btnLoading = true;
     console.log("param : ",param)
      this.api.checkInOpdPatientData(param).subscribe({
        next:(res)=>{
          if(res)
          {
          console.log("ress : ",res);
            this.toast.success('Patient Checked IN OPD')
            setTimeout(() => {
              this.btnLoading = false;
              this.modalService.dismissAll();
              this.router.navigate(['main/appointments/record/'+item.id+'/'+item.appointment.app_id])
            }, 500);
          
          }
        },
        error:(e)=>{
          this.btnLoading = false;
        }
      })
    }
    else
    {
     // alert('else')
     this.router.navigate(['main/appointments/record/'+item.id+'/'+item.appointment.app_id])
    }
   
  }
  customSearchFilter(event:any){
    this.filtersObject = event;
    this.loadData();
  }
  dateFilter(event:any)
  {
    //alert(event)
   this.dateQuery.setValue(event)
  }
  loadAppointmentByTab(type:any){
    this.selectedStatus = '';
    this.statusFilter$.next('');
    this.isFilteringOverbooked = false;
    if(type=="all"){
     
     this.dateFilter("")
     this.selected_tab = 'all'
    }
    else if(type=="today"){
      
      this.dateQuery.setValue({startDate:new Date(),endDate:new Date()})
           this.selected_tab = 'today'
    }
    else if(type=="tomorrow"){
      
      const today = new Date(); // Get the current date
      const tomorrow = new Date(today); // Create a new date object based on today
      tomorrow.setDate(today.getDate() + 1); // Add one day to the current date
      this.dateQuery.setValue({startDate:tomorrow,endDate:tomorrow})
         this.selected_tab = 'tomorrow'
    }

    else if(type=="week"){
      const today = new Date();

      // Get the current day of the week (0 = Sunday, 6 = Saturday)
      const dayOfWeek = today.getDay();
      
      // Calculate the start of the week (Sunday)
      const startOfWeek = new Date(today);
      startOfWeek.setDate(today.getDate() - dayOfWeek);
      
      // Calculate the end of the week (Saturday)
      const endOfWeek = new Date(today);
      endOfWeek.setDate(today.getDate() + (6 - dayOfWeek));
      
      this.dateQuery.setValue({startDate:startOfWeek,endDate:endOfWeek})
        this.selected_tab = 'week'
    }
    else if(type=="month"){
      const today = new Date();
      const currentMonthStart = new Date(today.getFullYear(), today.getMonth(), 1); // First day of the month
      const currentMonthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0); // Last day of the month
      this.dateQuery.setValue({startDate:currentMonthStart,endDate:currentMonthEnd})
         this.selected_tab = 'month'
    }





  }
  
    // load Initial table data from based on source type
    loadData()
    {
      try{
      // When in calendar view the table is not rendered, so MatSort/MatPaginator are
      // undefined. Fall back to a simple direct API call in that case.
      if (!this.sort || !this.paginator) {
        this.isDataLoading = true;
        let param: any = {
          where: { hospital_id: this.localStorage.getHospitalId(), center_id: this.localStorage.getCenterId() },
          filter: this.searchQuery.value,
          custom_filter: this.filtersObject,
          page: 0,
          limit: this.pageSize,
          order: [{ col: 'appointment_date', dir: 'desc' }, { col: 'appointment_time', dir: 'asc' }],
        };
        if (this.dateQuery.value) { param = { ...param, ...this.dateQuery.value }; }
        if (!this.localStorage.checkFullAccessForTableList(this.localStorage.getRole())) {
          param = { ...param, user_id: this.localStorage.getUserId() };
        }
        if (this.selectedStatus) {
          param = { ...param, status: this.selectedStatus };
        }
        this.fetchOverviewStats(param);
         this.api.getAllAppointmentWithCount(param).subscribe({
          next: (data: any) => {
            this.initialLoad = false;
            this.isDataLoading = false;
            if (data) {
              if (this.isFilteringOverbooked && data.rows) {
                const overbookedKeys = new Set(this.overbookedSlotsList.map(s => s.key));
                data.rows = data.rows.filter((item: any) => {
                  const app = item.appointment;
                  if (!app) return false;
                  const key = `${app.user_id}_${app.appointment_date}_${app.appointment_time}`;
                  return overbookedKeys.has(key);
                });
                data.count = data.rows.length;
              }
              this.exportArrayData = data.rows;
              this.dataSource = new MatTableDataSource<any>(data.rows);
              this.totalRows = data.count;
            }
          },
          error: () => { this.initialLoad = false; this.isDataLoading = false; }
        });
        return;
      }
     this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
     merge(this.dateQuery.valueChanges,this.searchQuery.valueChanges, this.sort.sortChange, this.paginator.page, this.statusFilter$).pipe(startWith({}),
     switchMap(()=>{
      this.isDataLoading = true;
      let param: any = {
        where:{hospital_id:this.localStorage.getHospitalId(),center_id:this.localStorage.getCenterId()},
        filter:this.searchQuery.value,
        custom_filter:this.filtersObject,
        page:(this.paginator.pageIndex *  this.paginator.pageSize),
        limit:this.paginator.pageSize,
        order:[{col:'appointment_date',dir:"desc"},{col:'appointment_time',dir:"asc"}],
      }
      if(this.dateQuery.value){param = {...param,...this.dateQuery.value}}
      if(this.localStorage.checkFullAccessForTableList(this.localStorage.getRole())){
        param = param
      }else{
        param = {...param,...{user_id:this.localStorage.getUserId()}}
      }
      if (this.selectedStatus) {
        param = { ...param, status: this.selectedStatus };
      }
      
      this.fetchOverviewStats(param);
     
      //console.log(this.localStorage.getRole())
      return  this.api.getAllAppointmentWithCount(param)
      .pipe(catchError(() => observableOf(null)));
      }),map((response:any)=>{
       this.initialLoad = false;
       if (response === null) {
         return [];
       }
       if (this.isFilteringOverbooked && response.rows) {
         const overbookedKeys = new Set(this.overbookedSlotsList.map(s => s.key));
         response.rows = response.rows.filter((item: any) => {
           const app = item.appointment;
           if (!app) return false;
           const key = `${app.user_id}_${app.appointment_date}_${app.appointment_time}`;
           return overbookedKeys.has(key);
         });
         response.count = response.rows.length;
       }
       if(this.selected_tab == 'all') {

        this.app_count  = {
          all:response.count,
          today:null,
          tomorrow:null,
          week:null,
          month:null
          }
      }
      else if(this.selected_tab == 'today') {
 
        this.app_count  = {
          all:null,
          today:response.count,
          tomorrow:null,
          week:null,
          month:null
          }
      }
      else if(this.selected_tab == 'tomorrow') {


        this.app_count  = {
          all:null,
          today:null,
          tomorrow: response.count,
          week:null,
          month:null
          }
      }
      else if(this.selected_tab == 'week') {
     
        this.app_count  = {
          all:null,
          today:null,
          week:response.count,
          tomorrow:null,
          month:null
          }
      }
      else if(this.selected_tab == 'month') {
  
        this.app_count  = {
          all:null,
          month:response.count,
          today:null,
          tomorrow:null,
          week:null,
          }
      }
      this.totalRows = response.count;
      return response
     })
     ).subscribe({
      next:(data) =>{
     // console.log(data)
      this.initialLoad = false;
          this.isDataLoading = false;
      this.exportArrayData = data.rows;
      this.dataSource = new MatTableDataSource<any>(data.rows);
      if(!this.localStorage.checkFeatures('opd')){
        this.displayedColumns = this.displayedColumns.filter(item=> item!='opd')
      }
      if(!this.localStorage.checkFeatures('online_payment')){
        this.displayedColumns = this.displayedColumns.filter(item=> item!='payment')
        this.exportColumns = ["pId","OPD No","Name","Mobile","Email","Doctor","Date","Time","Check In","Visit","Source","Status"];
      }
      else
      {
        this.isOnlinePayment = true;
        if(this.isOnlinePayment)
        {
          this.exportColumns = ["pId","OPD No","Name","Mobile","Email","Doctor","Date","Time","Check In","Visit","Source","Payment","Amount","Status"];
        } else {
          this.exportColumns = ["pId","OPD No","Name","Mobile","Email","Doctor","Date","Time","Check In","Visit","Source","Status"];
        }
      }
      // removing doctor for hospital wise
      if(this.localStorage.getHospitalWise() == "true") {
        this.exportColumns = this.exportColumns.filter((item:any) => item!='Doctor');
      }
      },
      error:(e)=>{
        this.initialLoad = false;
          this.isDataLoading = false;
       console.error(e)
      },
      complete:()=>{
        this.initialLoad = false;
      }
     })
    }
    catch(e){
      this.initialLoad = false;
     console.error(e)
    }}
  searchFilter(query:any){

   // alert(query)
    this.searchQuery.setValue(query);
  }
  open(content:any){
  
    this.modalService.open(content, { size:'lg', scrollable: false}).result.then(
			(result) => {
				this.closeResult = `Closed with: ${result}`;
			},
			(reason) => {
				this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
			},
		);

  }
   getDismissReason(reason: any): string {
		if (reason === ModalDismissReasons.ESC) {
			return 'by pressing ESC';
		} else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
			return 'by clicking on a backdrop';
		} else {
			return `with: ${reason}`;
		}
	}
  gotoPatient(item:any)
  {
    this.router.navigate(['main/appointments/record/'+item.id+'/'+item.appointment.app_id])
  }

  
  sourceImage = [{
    name:"webapp",
    img:"create.png"
  },
  {
    name:"tina",
    img:"tina-social.png"
  },
  {
    name:"whatsapp",
    img:"logos_whatsapp-icon.png"
  },
  {
    name:"twitter",
    img:"logos_twitter.png"
  },
  {
    name:"facebook",
    img:"logos_facebook.png"
  },
  {
    name:"instagram",
    img:"instagram-icon.png"
  },
  {
    name:"youtube",
    img:"logos_youtube-icon.png"
  },
  {
    name:"messenger",
    img:"logos_messenger.png"
  }]
  

  getsourceImage(source:any)
  {
    let img:any ="create.png";
  
    let tempImage:any =  this.sourceImage.find((item:any) => {
     return item.name === source;
    })
   //console.log(tempImage)
    if(tempImage)
    {
       img = tempImage.img
    }else
    {
      img = "create.png"
    }
    return img;

  }
  hideDropdown = false;

  async openReschedule(content:any,item:any)
  {

   if(item.appointment.appointment_type=="walk_in" || item.appointment.appointment_type=="emergency"  ){
        this.hideDropdown = true;
   }
   if(item.appointment.appointment_type!="walk_in" || item.appointment.appointment_type!="emergency"  ){
    this.appointment = item.appointment;
    const popup = this.modalService.open(content,  { windowClass:'modal modal-huge', scrollable: false,ariaLabelledBy: 'modal-basic-title', centered: true }).result;  
      await this.loadDates(item)
      if(this.DateList.length > 0)
      {
      
        
        this.loadTimes(item)
        let default_time = item?.appointment?.appointment_time;
        this.appointment.appointment_time = "";
        this.appointment.appointment_date = "";
        this.appointment.appointment_date =  item.appointment.appointment_date
        popup.then((result) => {  
          if (result === 'yes') {  
            //console.log(default_time)
            this.appointment.appointment_time = default_time;
          }  

        }, (reason) => { });  
      }
      else{
        this.toast.error("No dates for reschedule")
      }

   }
   else
   {
   
    this.toast.error("Reschedule is not available ")
   }


  
  }

  formatAppointmentType(type: any) {
    return type
      .toLowerCase()
      .split('_')
      .map((word:any) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  async loadDates(item:any)
  {
    this.DateList = []
    let param = {
      where: {
        hospital_id:this.localStorage.getHospitalId(),
        user_id:this.appointment.user_id,
        center_id:this.localStorage.getCenterId(),
        dept_id:item.appointment.user.dept_id,
      },
      appointment_type:item.appointment.appointment_type,
      timezone: this.localStorage.getTimeZone(),
      dateFormat: this.localStorage.getDateFormat()
  }
  if(this.localStorage.getIgnoreCenterCheck()=="true"){
    delete param.where.center_id;
  }
  const p = () => new Promise(resolve=>{
    this.api.getAvailableDays(param).subscribe({
      next:(response)=>{
         //console.log(response)
         if(response.length > 0 )
         {
          this.DateList = response;
         
          resolve(this.DateList);
    
         }
         else
         {
          this.toast.error("No Dates Available")
         }
    
       
      },
      error:(e)=>{

      }
    })
  })

  await p();
     
  }

  loadTimes(item:any)
  {
    this.TimeList = []
    let param = {
      where: {
        hospital_id:this.localStorage.getHospitalId(),
        user_id:item.appointment.user_id,
        center_id:this.localStorage.getCenterId(),
        dept_id:item.appointment.user.dept_id,
      },
      appointment_type:item.appointment.appointment_type,
      appointment_date:item.appointment.appointment_date,
      timezone:  this.localStorage.getTimeZone(),
      dateFormat: this.localStorage.getDateFormat()
  }
  //console.log(param)
  if(this.localStorage.getIgnoreCenterCheck()=="true"){
    delete param.where.center_id;
  }
      this.api.getSlots(param).subscribe({
        next:(response)=>{
           console.log(response)

           if(response.length > 0 )
           {
            this.TimeList = response;
           }
           else
           {
            this.toast.error("No Time Slots Available")
           }
      
        },
        error:(e)=>{

        }
      })
  }
  updateReschedule(isValid:any)
  {
    this.isSubmittedresCheduled = true;
    let param = {
      patient_id:this.appointment.patient_id,
      app_id:this.appointment.app_id,
      hospital_id:this.localStorage.getHospitalId(),
      appointment_date:this.appointment.appointment_date,
      appointment_time:this.appointment.appointment_time,
      status:"rescheduled"
    } 
    //console.log(param)
    if(this.appointment.appointment_date!="" && this.appointment.appointment_time !="")
    {
      this.btnLoading = true;
      this.api.updateAppointment(param).subscribe({
        next:(res)=>{
          this.modalService.dismissAll();
          this.toast.success("Appointment Rescheduled Successfully")
          this.loadData()
          this.btnLoading = false;
        },
        error:(e)=>{
          this.btnLoading = false;
        }
      })
     // console.log(this.appointment)
    }
    else
    {
      this.toast.error("Invalid Data")
    }
  
  }
 
  loadSlots(event:any)
  {

    const date = event.target.value;
    if(date!="")
    {
      //console.log(this.appointment)
      let param = {
        where: {
          hospital_id:this.localStorage.getHospitalId(),
          user_id:this.appointment.user_id,
          center_id:this.localStorage.getCenterId(),
          dept_id:this.appointment.user.dept_id,
        },
        appointment_type:this.appointment.appointment_type,
        appointment_date:date,
        timezone:  this.localStorage.getTimeZone(),
        dateFormat: this.localStorage.getDateFormat()
    }
    if(this.localStorage.getIgnoreCenterCheck()=="true"){
      delete param.where.center_id;
    }
    //console.log(param)
        this.api.getSlots(param).subscribe({
          next:(response)=>{
             //console.log(response)
             if(response.length > 0 )
             {
              this.TimeList = response;
             }
             else
             {
              this.toast.error("No Time Slots Available")
             }
          },
          error:(e)=>{
  
          }
        })
    }
    
    
  }

  cancelAppointmentfn(content:any,item:any)
  {
    this.selectedItem = item;
    this.modalService.open(content,  { windowClass:'modal modal-huge', scrollable: false,ariaLabelledBy: 'modal-basic-title', centered: true }).result.then((result) => {  
      if (result === 'yes') {  
      
      }  
    }, (reason) => {  

    });  
  }
  fnCancelAppointment()
  {
    let param = {
      patient_id:this.selectedItem .appointment.patient_id,
      app_id:this.selectedItem .appointment.app_id,
      hospital_id:this.localStorage.getHospitalId(),
      status:"cancelled",
    }
    this.btnLoading = true;
    this.api.updateAppointment(param).subscribe({
      next:(res)=>{
        this.modalService.dismissAll();
        this.btnLoading = false;
        this.toast.success("Appointment Cancelled Successfully")
        this.loadData()
      },
      
      error:(e)=>{
   this.btnLoading = false;
      }
    })
  }

  checkOut(content:any,item:any)
  {
    this.modalService.open(content,  { windowClass:'modal modal-huge', scrollable: false,ariaLabelledBy: 'modal-basic-title', centered: true }).result.then((result) => {  
      if (result === 'yes') {  
        let param = {
          patient_id:item.appointment.patient_id,
          app_id:item.appointment.app_id,
          mobile: item.mobile,
          hospital_id:this.localStorage.getHospitalId(),
          status:'check_out',
        }
        this.api.updateAppointment(param).subscribe({
          next:(res)=>{
            this.modalService.dismissAll();
            this.loadData()
            this.toast.success("Appointment Updated Successfully")
          },
          error:(e)=>{
    
          }
        })
      }  
    }, (reason) => {  

    });  
  }
   toNormalCapitalization(text:any) {
    return text.toLowerCase().replace(/(?:^|\s)\S/g, function(a:any) { return a.toUpperCase(); });
}
  completeAppointmentfn(content:any,item:any)
  {
  
    this.selectedItem = item;
    if(this.isOnlinePayment){
      if(this.selectedItem.appointment.details!=null)
      {
        this.paymentDetail.payment_status = this.selectedItem?.appointment?.payment_status  || this.paymentDetail.payment_status 
        this.paymentDetail.remarks = this.selectedItem?.appointment?.details?.remarks  || this.paymentDetail.remarks
        this.paymentDetail.service = this.selectedItem?.appointment?.details?.service  || this.paymentDetail.service
        this.paymentDetail.pincode = this.selectedItem?.appointment?.details?.pincode  || this.paymentDetail.pincode
      }
    }
    this.modalService.open(content,  { windowClass:'modal modal-huge', scrollable: false,ariaLabelledBy: 'modal-basic-title', centered: true }).result.then((result) => {},(reason) => {});  

    // //console.log(this.selectedItem)
    // if(this.isOnlinePayment){
    //   if(this.selectedItem?.appointment?.details.payment_status=="succeeded"){
    //     console.log(this.selectedItem)
    //    // this.checkInOPD(this.selectedItem);
    //   }
    //   else{
    //     this.modalService.open(content,  { size:'sm', scrollable: false,ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {},(reason) => {});  
    //   }
    // }
    // else
    // {
    //    this.modalService.open(content,  { size:'sm', scrollable: false,ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {},(reason) => {});  
    // }
  }

  fnClickCheckin()
{

    if(this.isOnlinePayment)
    {
     // this.paymentDetail = this.selectedItem?.appointment?.details.payment_status!="" || this.paymentDetail
      if(this.paymentDetail.payment_status=="succeeded" || this.paymentDetail.payment_status=="pending" || this.paymentDetail.payment_status=="failed"){
        //this.checkInOPD(this.selectedItem);
       // console.log(this.paymentDetail.remarks)
        this.selectedItem.appointment.details = {
          remarks: this.paymentDetail.remarks,
          service: this.paymentDetail.service,
          pincode: this.paymentDetail.pincode,
        };
        this.selectedItem.appointment.payment_status = this.paymentDetail.payment_status;
      //  console.log(this.selectedItem)
        this.checkInOPD(this.selectedItem);
      }
      else{
        this.toast.error("Payment not done for this appointment")
      }
    }
    else
    {
      this.checkInOPD(this.selectedItem);
    }
  }

  onRowClick(item: any, template: any) {
    const status = item.appointment?.status?.toLowerCase();
    if (status === 'check_in' || status === 'check_out') {
      this.view(item);
    } else if (status === 'booked' || status === 'rescheduled') {
      this.completeAppointmentfn(template, item);
    } else {
      this.view(item);
    }
  }

  onFileChange(args: any)
  {
    const target: DataTransfer = <DataTransfer>(args.target);
    if (target.files.length !== 1) {
      throw new Error('Cannot use multiple files');
    }
    const reader: FileReader = new FileReader();
    reader.readAsBinaryString(target.files[0]);
    reader.onload = (e: any) => {
      /* create workbook */
      const binarystr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(binarystr, { type: 'binary' });

      /* selected the first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];

      /* save data */
      const data = XLSX.utils.sheet_to_json(ws); // to get 2d array pass 2nd parameter as object {header: 1}
      //console.log(data); // Data will be logged in array format containing objects
    };
  }
  export(header:any){
    //console.log(header)
    let excelRowData:any = [];
    console.log("exportArrayData : ",this.exportArrayData)
    this.exportArrayData.forEach((element:any) => {
     let status = "";
     if( element.appointment.status=="booked")
     {
       status = element.appointment.status.replaceAll('booked','Booked')
     }
     else if( element.appointment.status=="check_in" )
     {
       status = element.appointment.status.replaceAll('check_in','Checked In')
     }
     else if( element.appointment.status=="rescheduled" )
     {
       status = element.appointment.status.replaceAll('rescheduled','Rescheduled')
     }
     else if( element.appointment.status=="cancelled")
     {
       status = element.appointment.status.replaceAll('cancelled','Cancelled')
     }
     else if( element.appointment.status=="no_show")
     {
       status = element.appointment.status.replaceAll('no_show','No Show')
     }
     
     if(this.isOnlinePayment)
     {
     excelRowData.push({0:element.pId,1:element.appointment.opd_number,2:element.fname+" "+element.lname,3:element.mobile,4:element.email,5:element.appointment.user.fname+" "+element.appointment.user.lname,6:element.appointment.appointment_date,7:element.appointment.appointment_time,8:element.appointment.check_in_type,9:element.appointment.appointment_type,10:element.appointment.appointment_source,11:element.appointment?.details?.payment_status || "",12:element.appointment?.details?.amount || "",13:status})
     } else
     {
      excelRowData.push({0:element.pId,1:element.appointment.opd_number,2:element.fname+" "+element.lname,3:element.mobile,4:element.email,5:element.appointment.user.fname+" "+element.appointment.user.lname,6:element.appointment.appointment_date,7:element.appointment.appointment_time,8:element.appointment.check_in_type,9:element.appointment.appointment_type,10:element.appointment.appointment_source,11:status})
     }

   });
   console.log("excelRowData : ",excelRowData);

    let excelData = [];
    let excelHeader = [];
      for (let i = 0; i < excelRowData.length; i++) {
        let element = excelRowData[i];
        let obj:any = {}
        for (let index = 0; index < header.length; index++) {
          let key = header[index]['key'];
          obj[key] = element[key]
        }
        excelData.push(obj)
      }
      for (let index = 0; index < header.length; index++) {
        let value = header[index]['value'];
        excelHeader.push(value)
      }
    //console.log(excelData)
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    const ws: XLSX.WorkSheet =XLSX.utils.json_to_sheet([]);
    XLSX.utils.sheet_add_aoa(ws, [excelHeader]);
    XLSX.utils.sheet_add_json(ws,excelData, { origin: 'A2', skipHeader: true });
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    let date = new Date();
    let day = date.getDate();
    let month = date.getMonth()+1;
    let year = date.getFullYear();

    XLSX.writeFile(wb, "Appointments_data_"+day+"_"+month+"_"+year+"_"+date.getTime()+".csv");
  }

  noShowAppointmentfn(content:any,item:any){
    this.modalService.open(content,  { windowClass:'modal modal-huge', scrollable: false,ariaLabelledBy: 'modal-basic-title', centered: true }).result.then((result) => {  
      if (result === 'yes') {  
        let param = {
          patient_id:item.appointment.patient_id,
          app_id:item.appointment.app_id,
          hospital_id:this.localStorage.getHospitalId(),
          status:"no-show",
        }
        this.api.updateAppointment(param).subscribe({
          next:(res)=>{
            this.modalService.dismissAll();
            this.toast.success("Appointment Updated Successfully")
            this.loadData()
          },
          error:(e)=>{
    
          }
        })
      }  
    }, (reason) => {  
    });  
  }

  apptnotes:any = null;
  remarkNote = "";
  reasonNote = "";
  selectedRow: any = null;
  removeRow: any = null;
  updateRow: any = null;
  updateRemark = "";
  updateReason = "";
  selectedIndex:any = null;

  clearNote(){
    this.apptnotes = null;
    this.remarkNote = "";
    this.reasonNote = "";
    this.selectedRow = null;
    this.removeRow = null;
    this.updateRow = null;
    this.updateRemark = "";
    this.updateReason = "";
  }

  addNotesToAppointmentfn(content:any,item:any){
    this.apptnotes = item.appointment.apptRemarks;
    this.selectedRow = item;
    console.log("result 1 : ",this.selectedRow)
    this.modalService.open(content,  { windowClass:'modal modal-lg', scrollable: false,ariaLabelledBy: 'modal-basic-title', centered: true }).result.then((result) => {  

    });  
  }

  removeNotesToAppointmentfn(content:any,item:any,i:any){
    this.removeRow = item;
    this.selectedIndex = i;
    this.removeModalRef= this.modalService.open(content,  { windowClass:'modal modal-sm', scrollable: false,ariaLabelledBy: 'modal-basic-title', centered: true });
  }

  updateNotesToAppointmentfn(content:any,item:any,i:any){
    this.updateRow = item;
    this.updateRemark = item.remark;
    this.updateReason = item.reason;
    this.selectedIndex = i;
    this.updateModalRef = this.modalService.open(content,  { windowClass:'modal modal-sm', scrollable: false,ariaLabelledBy: 'modal-basic-title', centered: true });
  }

  addNote() {
    if(this.remarkNote) {
      this.btnLoading = true;
      console.log("remarks qqww : ",this.selectedRow)
      let now = new Date();
      let date = new Intl.DateTimeFormat('en-GB').format(now).replace(/\//g, '-'); // e.g., "11/27/2024"
      let time = now.toLocaleTimeString(); // e.g., "10:15:30 AM"
      let len = this.selectedRow.appointment.apptRemarks?.length || 0;
      let note = {
        "id": len + 1,
        "remark": this.remarkNote,
        "reason": this.reasonNote,
        "date": date,
        "time": time
      } 
      
      let param = {
          "app_id": this.selectedRow.appointment.app_id,
          "hospital_id": this.selectedRow.hospital_id,
          "updateData" : {
              "apptRemark": note
          }
      }
      console.log("parms note : ",param);
      this.api.updateAppointmentData(param).subscribe({
        next:(res:any)=>{
          console.log("res : ",res);
          if(res) {
            if(this.selectedRow.appointment.apptRemarks){
              this.selectedRow.appointment.apptRemarks.push(note);
            }
            else {
              this.selectedRow.appointment.apptRemarks = [note];
            }
            console.log("remarks 2 : ",this.selectedRow)

            const data = this.dataSource.data;
            const rowToUpdate = data.find((item) => item.id === this.selectedRow.id);
            if (rowToUpdate) {
              Object.assign(rowToUpdate, this.selectedRow); // Update only the changed fields
            }
            // Refresh the table (optional if Angular detects changes automatically)
            this.dataSource.data = data;
            this.apptnotes = this.selectedRow.appointment.apptRemarks;
            this.remarkNote = "";
            this.reasonNote = "";
            this.btnLoading = false;
          }
          this.toast.success("Appointment Note Added Successfully")
        },
        error:(e)=>{
          
        } 
      }); 
    }
  }

  removeThisNote() {
    this.removBtnLoading = true;
    console.log("ree 1 : ",this.selectedRow);
    console.log("ree 2 : ",this.removeRow);
    let item = this.removeRow;
    let param = {
      "app_id": this.selectedRow.appointment.app_id,
      "hospital_id": this.selectedRow.hospital_id,
      "updateData" : {
          "removeRemark": {
            "id": item.id
          }
      }
  }
  console.log("note param : ",param);
  this.btnClose = true;
  this.api.updateAppointmentData(param).subscribe({
    next:(res:any)=>{
      console.log("res : ",res);
      if(res) {
        if(this.selectedRow.appointment.apptRemarks){
          this.selectedRow.appointment.apptRemarks = this.selectedRow.appointment.apptRemarks.filter(
            (remark:any) => remark.id !== item.id
          );
        }
        // else {
        //   this.selectedRow.appointment.apptRemarks = [note];
        // }
        console.log("remarks 2 : ",this.selectedRow)
        // if (!this.apptnotes) {
        //   this.apptnotes = [];
        // }
        // this.apptnotes.push(note);
        const data = this.dataSource.data;
  
        // Find and update the selected row directly
        const rowToUpdate = data.find((item) => item.id === this.selectedRow.id);
        if (rowToUpdate) {
          Object.assign(rowToUpdate, this.selectedRow); // Update only the changed fields
        }
    
        // Refresh the table (optional if Angular detects changes automatically)
        this.dataSource.data = data;
        this.remarkNote = "";
        this.reasonNote = "";
        this.removBtnLoading = false;
        this.apptnotes = this.selectedRow.appointment.apptRemarks;
        this.removeModalRef?.close();
      }
      this.toast.success("Note Removed !")
    },
    error:(e)=>{
          
    } 
  }); 
  }

  updateThisNote() {
      let item = this.updateRow;
      this.UpdateBtnLoading = true;
      console.log("remarks qqww : ",this.selectedRow)
      let note = {
        "id": item.id,
        "remark": this.updateRemark,
        "reason": this.updateReason
      } 
      
      let param = {
          "app_id": this.selectedRow.appointment.app_id,
          "hospital_id": this.selectedRow.hospital_id,
          "updateData" : {
              "updateRemark": note
          }
      }

      console.log("parms note : ",param);
      this.api.updateAppointmentData(param).subscribe({
        next:(res:any)=>{
          console.log("res : ",res);
          if(res) {
            // if(this.selectedRow.appointment.apptRemarks){
              this.selectedRow.appointment.apptRemarks[this.selectedIndex]['remark']= this.updateRemark;
              this.selectedRow.appointment.apptRemarks[this.selectedIndex]['reason'] = this.updateReason;
              console.log("uodated remark : ",this.selectedRow);
            // }

            console.log("remarks 2 : ",this.selectedRow)

            const data = this.dataSource.data;
            const rowToUpdate = data.find((item) => item.id === this.selectedRow.id);
            if (rowToUpdate) {
              Object.assign(rowToUpdate, this.selectedRow); // Update only the changed fields
            }
        
            // Refresh the table (optional if Angular detects changes automatically)
            this.dataSource.data = data;
            this.remarkNote = "";
            this.reasonNote = "";
            this.UpdateBtnLoading = false;
            this.apptnotes = this.selectedRow.appointment.apptRemarks;
            this.updateModalRef?.close();
          }
          this.toast.success("Appointment Note Updated Successfully")
        },
        error:(e)=>{
          
        } 
      }); 
  }

  enableUpdate(){
    this.showUpdateBtn = true;
  }

  apptForRefund: any = {}

  openRefundWindow(refundAppointment:any, element:any) {
    this.apptForRefund = element;
    this.modalService.open(refundAppointment,  { windowClass:'modal modal-sm', scrollable: false,ariaLabelledBy: 'modal-basic-title', centered: true });
  }

  changePaymentStat() {
    console.log("sle appt : ",this.apptForRefund)
  }

  toggleMobileInfo(element: any){
    this.mobileInfoVisible = this.mobileInfoVisible === element.appointment.app_id ? null : element.appointment.app_id;
      if (window.innerWidth > 768) {
        this.current_id_hover = "";
      }
  }
  @HostListener('window:resize', ['$event'])
      onResize(event: Event) {
      if (window.innerWidth > 1024) {
        this.mobileInfoVisible = false;
        this.current_id_hover = "";
        
    this.isMobileView = window.innerWidth <= 1024;
      }
    }
  handleShowInfo(element: any, event: any){
    this.showInfo(element, event);
    this.toggleMobileInfo(element);
  }


handleScrollLeft() {
  const container = this.scrollContainer.nativeElement;
  container.scrollBy({ left: -150, behavior: 'smooth' });
  setTimeout(() => this.updateScrollThumb(), 300);
}

handleScrollRight() {
  const container = this.scrollContainer.nativeElement;
  container.scrollBy({ left: 150, behavior: 'smooth' });
  setTimeout(() => this.updateScrollThumb(), 300);
}

updateScrollThumb() {
  if (!this.scrollContainer) return;

  const container = this.scrollContainer.nativeElement;
  const scrollWidth = container.scrollWidth;
  const clientWidth = container.clientWidth;
  const scrollLeft = container.scrollLeft;

  if (scrollWidth > clientWidth) {
    this.scrollThumbWidth = Math.max(10, Math.min(100, (clientWidth / scrollWidth) * 100));
    const maxScrollLeft = scrollWidth - clientWidth;
    const scrollPercentage = (scrollLeft / maxScrollLeft) * 100;
    this.scrollThumbLeft = (scrollPercentage * (100 - this.scrollThumbWidth)) / 100;
    this.scrollThumbLeft = Math.max(0, Math.min(100 - this.scrollThumbWidth, this.scrollThumbLeft));
  } else {
    this.scrollThumbWidth = 100;
    this.scrollThumbLeft = 0;
  }
}

  // ===== Calendar View =====
  showAppointmentCalendar = false;
  calendarCurrentDate: Date = new Date();
  calendarWeekDays: Date[] = [];
  // 48 half-hour slots: slot 0 = 00:00, slot 1 = 00:30, slot 2 = 01:00 … slot 47 = 23:30
  calendarSlots: number[] = Array.from({ length: 48 }, (_, i) => i);

  onToggleCalendarView(value: boolean) {
    this.showAppointmentCalendar = value;
    if (value) {
      this.generateCalendarWeek();
      this.loadCalendarData();
      setTimeout(() => {
        const scrollArea = document.querySelector('.cal-scroll-area');
        if (scrollArea) {
          scrollArea.scrollTop = Math.max(0, this.getCurrentTimeTop() - 150);
        }
      }, 100);
    } else {
      this.isDataLoading = true;
      this.selected_tab = 'all';
      this.dateQuery.setValue("");
    }
  }

  loadCalendarData(): void {
    if (!this.calendarWeekDays.length) return;
    const first = new Date(this.calendarWeekDays[0]);
    first.setHours(0, 0, 0, 0);
    const last  = new Date(this.calendarWeekDays[6]);
    last.setHours(23, 59, 59, 999);
    
    this.isDataLoading = true;
    const param: any = {
      where: {
        hospital_id: this.localStorage.getHospitalId(),
        center_id:   this.localStorage.getCenterId()
      },
      startDate: first,
      endDate:   last,
      custom_filter: this.filtersObject,
      page:  0,
      limit: 500,
      order: [{ col: 'appointment_date', dir: 'asc' }, { col: 'appointment_time', dir: 'asc' }],
    };
    if (!this.localStorage.checkFullAccessForTableList(this.localStorage.getRole())) {
      param.user_id = this.localStorage.getUserId();
    }
    if (this.localStorage.getIgnoreCenterCheck() === 'true') {
      delete param.where.center_id;
    }
    this.api.getAllAppointmentWithCount(param).subscribe({
      next: (data: any) => {
        this.isDataLoading = false;
        if (data) {
          this.dataSource.data = data.rows;
        }
      },
      error: () => { this.isDataLoading = false; }
    });
  }

  // ===== Calendar Slot Selection (Teams-style Create Appointment) =====
  calSlotSelecting = false;
  calSlotDay: Date | null = null;
  calSlotStartHour = 0;
  calSlotStartMinute = 0;
  calSlotEndHour = 0;
  calSlotEndMinute = 30;
  calSlotPopoverVisible = false;
  calSlotPopoverX = 0;
  calSlotPopoverY = 0;
  calSlotDepartmentList: any[] = [];
  calSlotDoctorList: any[] = [];
  calSlotDateList: any[] = [];
  calSlotTimeList: any[] = [];
  calSlotDoctorLoading = false;
  calSlotBtnLoading = false;
  calSlotIsSubmitted = false;
  calSlotSearchQuery = '';
  calSlotSearching = false;
  calSlotAppt: any = {
    fname: '', lname: '', prefix: '', gender: 'N/A', mobile: '',
    age: 0, email: '', dept_id: '', user_id: '', appointment_type: 'walk_in',
    appointment_date: '', appointment_time: '', check_in_type: 'new',
    appointment_source: 'webapp', status: 'booked', hospital_id: 0,
    center_id: 0, timezone: '', patient_id: 0
  };

  onCalSlotMouseDown(event: MouseEvent, day: Date, slot: number): void {
    const target = event.target as HTMLElement;
    if (target.closest('.cal-appt-card')) return;
    event.preventDefault();
    this.calSlotSelecting = true;
    this.calSlotDay = new Date(day);
    this.calSlotStartHour   = Math.floor(slot / 2);
    this.calSlotStartMinute = (slot % 2) * 30;
    this.calSlotEndHour     = this.calSlotStartHour;
    this.calSlotEndMinute   = this.calSlotStartMinute + 30 >= 60 ? 0 : this.calSlotStartMinute + 30;
  }

  onCalSlotMouseEnter(day: Date, slot: number): void {
    if (!this.calSlotSelecting || !this.calSlotDay) return;
    if (this.isSameCalDay(day, this.calSlotDay)) {
      this.calSlotEndHour   = Math.floor(slot / 2);
      this.calSlotEndMinute = (slot % 2) * 30 + 30 >= 60 ? 0 : (slot % 2) * 30 + 30;
    }
  }

  @HostListener('document:mouseup', ['$event'])
  onDocumentMouseUp(event: MouseEvent): void {
    if (!this.calSlotSelecting || !this.calSlotDay) return;
    this.calSlotSelecting = false;

    const d = this.calSlotDay;
    const dateStr = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    const startH = String(this.calSlotStartHour).padStart(2, '0');
    const startM = String(this.calSlotStartMinute).padStart(2, '0');

    // Reset form
    this.calSlotAppt = {
      fname: '', lname: '', prefix: 'Mr', gender: 'N/A', mobile: '',
      age: 0, email: '', dept_id: '', user_id: '', appointment_type: 'walk_in',
      appointment_date: dateStr, appointment_time: `${startH}:${startM}`,
      check_in_type: 'new', appointment_source: 'webapp', status: 'booked',
      hospital_id: 0, center_id: 0, timezone: '', patient_id: 0
    };
    this.calSlotIsSubmitted = false;
    this.calSlotSearchQuery = '';
    this.calSlotDoctorList = [];
    this.calSlotDateList = [];
    this.calSlotTimeList = [];

    // Position the popover near mouse cursor, keep it inside viewport
    const popW = 400, popH = 520;
    let x = event.clientX + 14;
    let y = event.clientY - 60;
    if (x + popW > window.innerWidth - 10) x = event.clientX - popW - 14;
    if (y + popH > window.innerHeight - 10) y = window.innerHeight - popH - 10;
    if (y < 60) y = 60;
    this.calSlotPopoverX = x;
    this.calSlotPopoverY = y;
    this.calSlotPopoverVisible = true;

    if (!this.calSlotDepartmentList.length) {
      this.loadCalSlotDepartments();
    }
  }

  isCalSlotHighlighted(day: Date, slot: number): boolean {
    if ((!this.calSlotSelecting && !this.calSlotPopoverVisible) || !this.calSlotDay) return false;
    if (!this.isSameCalDay(day, this.calSlotDay)) return false;
    const startSlot = this.calSlotStartHour * 2 + (this.calSlotStartMinute >= 30 ? 1 : 0);
    const endSlot   = this.calSlotEndHour   * 2 + (this.calSlotEndMinute   >= 30 ? 1 : 0);
    const minS = Math.min(startSlot, endSlot);
    const maxS = Math.max(startSlot, endSlot);
    return slot >= minS && slot <= maxS;
  }

  isSameCalDay(a: Date, b: Date): boolean {
    return a.getFullYear() === b.getFullYear() &&
      a.getMonth() === b.getMonth() &&
      a.getDate() === b.getDate();
  }

  closeCalSlotPopover(): void {
    this.calSlotPopoverVisible = false;
    this.calSlotDay = null;
    this.calSlotSelecting = false;
  }

  loadCalSlotDepartments(): void {
    const param = { where: { hospital_id: this.localStorage.getHospitalId(), isPublic: true } };
    this.api.getDepartments(param).subscribe({
      next: (response) => {
        if (response && response.length > 0) {
          this.calSlotDepartmentList = response;
        }
      },
      error: () => {}
    });
  }

  onCalSlotDeptChange(event: any): void {
    const deptId = event.target.value;
    this.calSlotAppt.user_id = '';
    this.calSlotDoctorList = [];
    this.calSlotDateList = [];
    this.calSlotTimeList = [];
    if (this.calSlotAppt.appointment_type !== 'walk_in' && this.calSlotAppt.appointment_type !== 'emergency') {
        this.calSlotAppt.appointment_date = '';
        this.calSlotAppt.appointment_time = '';
    }
    if (!deptId) return;
    const param: any = {
      hospital_id: this.localStorage.getHospitalId(),
      center_id: this.localStorage.getCenterId(),
      dept_id: deptId,
    };
    if (this.localStorage.getIgnoreCenterCheck() === 'true') delete param.center_id;
    this.calSlotDoctorLoading = true;
    this.api.getUserByDepartmentSchedule(param).subscribe({
      next: (response) => { this.calSlotDoctorList = response; this.calSlotDoctorLoading = false; },
      error: () => { this.calSlotDoctorLoading = false; }
    });
  }

  onCalSlotDoctorChange(): void {
    this.loadCalSlotDates();
  }

  onCalSlotTypeChange(): void {
    if (this.calSlotAppt.appointment_type !== 'walk_in' && this.calSlotAppt.appointment_type !== 'emergency') {
      this.loadCalSlotDates();
    } else {
      const startH = String(this.calSlotStartHour).padStart(2, '0');
      const startM = String(this.calSlotStartMinute).padStart(2, '0');
      if (this.calSlotDay) {
        this.calSlotAppt.appointment_date = `${this.calSlotDay.getFullYear()}-${String(this.calSlotDay.getMonth() + 1).padStart(2, '0')}-${String(this.calSlotDay.getDate()).padStart(2, '0')}`;
      }
      this.calSlotAppt.appointment_time = `${startH}:${startM}`;
      this.calSlotDateList = [];
      this.calSlotTimeList = [];
    }
  }

  loadCalSlotDates(): void {
    if (!this.calSlotAppt.user_id || !this.calSlotAppt.dept_id || !this.calSlotAppt.appointment_type) {
      return;
    }
    if (this.calSlotAppt.appointment_type === 'walk_in' || this.calSlotAppt.appointment_type === 'emergency') {
      return;
    }

    this.calSlotDateList = [];
    this.calSlotTimeList = [];
    this.calSlotAppt.appointment_date = '';
    this.calSlotAppt.appointment_time = '';

    const param: any = {
      where: {
        hospital_id: this.localStorage.getHospitalId(),
        user_id: this.calSlotAppt.user_id,
        center_id: this.localStorage.getCenterId(),
        dept_id: this.calSlotAppt.dept_id,
      },
      appointment_type: this.calSlotAppt.appointment_type,
      timezone: this.localStorage.getTimeZone(),
      dateFormat: this.localStorage.getDateFormat()
    };
    if (this.localStorage.getIgnoreCenterCheck() === 'true') {
      delete param.where.center_id;
    }

    this.api.getAvailableDays(param).subscribe({
      next: (response) => {
        if (response && response.length > 0) {
          this.calSlotDateList = response;
        } else {
          this.toast.error("No Dates Available");
        }
      },
      error: () => {}
    });
  }

  loadSlotsForCalSlot(): void {
    const date = this.calSlotAppt.appointment_date;
    if (!date) return;
    
    this.calSlotTimeList = [];
    this.calSlotAppt.appointment_time = '';

    const param: any = {
      where: {
        hospital_id: this.localStorage.getHospitalId(),
        user_id: this.calSlotAppt.user_id,
        center_id: this.localStorage.getCenterId(),
        dept_id: this.calSlotAppt.dept_id,
      },
      appointment_type: this.calSlotAppt.appointment_type,
      appointment_date: date,
      timezone: this.localStorage.getTimeZone(),
      dateFormat: this.localStorage.getDateFormat()
    };
    if (this.localStorage.getIgnoreCenterCheck() === 'true') {
      delete param.where.center_id;
    }

    this.api.getSlots(param).subscribe({
      next: (response) => {
        if (response && response.length > 0) {
          this.calSlotTimeList = response;
        } else {
          this.toast.error("No Time Slots Available");
        }
      },
      error: () => {}
    });
  }

  searchCalSlotPatient(): void {
    if (!this.calSlotSearchQuery.trim()) return;
    this.calSlotSearching = true;
    const data = {
      hospital_id: this.localStorage.getHospitalId(),
      center_id: this.localStorage.getCenterId(),
      filter: { mobile: this.calSlotSearchQuery.trim() }
    };
    this.api.getPatientBySearch(data).subscribe({
      next: (res: any) => {
        this.calSlotSearching = false;
        if (res) {
          this.calSlotAppt.fname = res.fname || '';
          this.calSlotAppt.lname = res.lname || '';
          this.calSlotAppt.prefix = res.prefix || 'Mr';
          this.calSlotAppt.mobile = res.mobile || this.calSlotSearchQuery;
          this.calSlotAppt.email = res.email || '';
          this.calSlotAppt.age = res.age || 0;
          this.calSlotAppt.gender = res.gender || 'N/A';
          this.calSlotAppt.patient_id = res.id || 0;
          this.calSlotAppt.check_in_type = 'follow-up';
          this.toast.success('Patient found');
        } else {
          this.toast.info('No patient found — fill in details manually');
        }
      },
      error: () => {
        this.calSlotSearching = false;
        this.toast.info('No patient found — fill in details manually');
      }
    });
  }

  saveCalSlotAppointment(): void {
    this.calSlotIsSubmitted = true;
    const a = this.calSlotAppt;
    if (!a.fname || !a.lname || !a.mobile || !a.dept_id || !a.user_id ||
      !a.appointment_type || !a.appointment_date || !a.appointment_time) {
      this.toast.error('Please fill all required fields');
      return;
    }
    this.calSlotBtnLoading = true;
    const payload = {
      ...a,
      hospital_id: this.localStorage.getHospitalId(),
      center_id: this.localStorage.getCenterId(),
      check_in_type: a.check_in_type || 'new',
      appointment_source: 'webapp',
      status: 'booked',
      timezone: this.localStorage.getTimeZone(),
    };
    this.api.createAppointment(payload).subscribe({
      next: (res: any) => {
        if (res && res.slotbusy) {
          this.toast.error("This slot has already been booked. Please select a different time slot.");
          this.calSlotBtnLoading = false;
          this.calSlotAppt.appointment_time = "";
          if (this.calSlotAppt.appointment_date) {
            this.loadSlotsForCalSlot();
          }
          return;
        }
        this.calSlotBtnLoading = false;
        this.closeCalSlotPopover();
        this.toast.success('Appointment Created Successfully');
        this.isDataLoading = true;
        this.loadData();
      },
      error: () => { this.calSlotBtnLoading = false; }
    });
  }

  generateCalendarWeek() {
    const date = new Date(this.calendarCurrentDate);
    const day = date.getDay();
    const diffToMonday = day === 0 ? -6 : 1 - day;
    date.setDate(date.getDate() + diffToMonday);
    this.calendarWeekDays = [];
    for (let i = 0; i < 7; i++) {
      const d = new Date(date);
      d.setDate(date.getDate() + i);
      this.calendarWeekDays.push(d);
    }
  }

  calendarPrevWeek() {
    this.calendarCurrentDate = new Date(this.calendarCurrentDate);
    this.calendarCurrentDate.setDate(this.calendarCurrentDate.getDate() - 7);
    this.generateCalendarWeek();
    this.loadCalendarData();
  }

  calendarNextWeek() {
    this.calendarCurrentDate = new Date(this.calendarCurrentDate);
    this.calendarCurrentDate.setDate(this.calendarCurrentDate.getDate() + 7);
    this.generateCalendarWeek();
    this.loadCalendarData();
  }

  calendarGoToToday() {
    this.calendarCurrentDate = new Date();
    this.generateCalendarWeek();
    this.loadCalendarData();
  }

  /** slot is 0-based half-hour index (0=00:00, 1=00:30, 2=01:00 …) */
  getAppointmentsForCell(date: Date, slot: number): any[] {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    const dateStr = `${y}-${m}-${d}`;
    const slotHour   = Math.floor(slot / 2);
    const slotMinute = (slot % 2) * 30;
    return this.dataSource.data.filter((item: any) => {
      const appDate = (item.appointment.appointment_date || '').substring(0, 10);
      const appTime = item.appointment.appointment_time || '00:00';
      const parts   = appTime.split(':');
      const appHour = parseInt(parts[0], 10);
      const appMin  = parseInt(parts[1] || '0', 10);
      // Match the half-hour bucket
      const appSlot = appHour * 2 + (appMin >= 30 ? 1 : 0);
      return appDate === dateStr && appSlot === slot;
    });
  }

  /**
   * Returns layout metadata for all appointments in a 30-min slot so that
   * overlapping cards are placed side-by-side instead of stacking on top of
   * each other.
   *
   * Each entry:  { appt, col, total, topPx }
   *   col   – zero-based column index this card occupies
   *   total – how many appointments share this slot (so width = 100%/total)
   *   topPx – pixel offset inside the row based on actual minutes
   */
  getAppointmentsWithLayout(date: Date, slot: number): {
    appt: any; col: number; total: number; topPx: number;
  }[] {
    const appts = this.getAppointmentsForCell(date, slot);
    const total = appts.length;
    return appts.map((appt: any, col: number) => ({
      appt,
      col,
      total,
      topPx: this.getAppointmentTopOffset(appt.appointment.appointment_time),
    }));
  }

  /** pixel offset within a 30-min row (slot height is 56px) */
  getAppointmentTopOffset(time: string): number {
    const parts  = (time || '00:00').split(':');
    const minutes = parseInt(parts[1] || '0', 10);
    // Within a 30-min slot, sub-minute offset (0–29 mins → 0–55px)
    return Math.round((minutes % 30) / 30 * 54);
  }

  isToday(date: Date): boolean {
    const today = new Date();
    return date.getFullYear() === today.getFullYear() &&
      date.getMonth() === today.getMonth() &&
      date.getDate() === today.getDate();
  }

  /** Returns px position of current-time line. Each 30-min slot = 56px. */
  getCurrentTimeTop(): number {
    const now = new Date();
    const totalMinutes = now.getHours() * 60 + now.getMinutes();
    return Math.round(totalMinutes / 30 * 56);
  }

  calendarMonthYearLabel(): string {
    if (!this.calendarWeekDays.length) return '';
    const months = ['January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'];
    const first = this.calendarWeekDays[0];
    const last = this.calendarWeekDays[6];
    if (first.getMonth() === last.getMonth()) {
      return `${months[first.getMonth()]} ${first.getFullYear()}`;
    }
    return `${months[first.getMonth()]} \u2013 ${months[last.getMonth()]} ${last.getFullYear()}`;
  }

  /** Format a half-hour slot index into a readable time label */
  formatSlot(slot: number): string {
    if (slot === 0) return '';
    const h = Math.floor(slot / 2);
    const m = (slot % 2) * 30;
    const mStr = m === 0 ? '00' : '30';
    if (h === 0)  return m === 0 ? '' : `12:${mStr} AM`;
    if (h < 12)   return `${h}:${mStr} AM`;
    if (h === 12) return `12:${mStr} PM`;
    return `${h - 12}:${mStr} PM`;
  }

  getSidebarCount(status: string): number {
    if (!this.dataSource || !this.dataSource.data) return 0;
    return this.dataSource.data.filter(item => {
      const s = item.appointment?.status?.toLowerCase();
      if (status === 'in_progress') return s === 'check_in';
      if (status === 'waiting') return s === 'booked';
      if (status === 'upcoming') return s === 'rescheduled';
      if (status === 'completed') return s === 'check_out';
      return false;
    }).length;
  }

  getTabOverviewTitle(): string {
    switch (this.selected_tab) {
      case 'today':
        return "Today's Overview";
      case 'tomorrow':
        return "Tomorrow's Overview";
      case 'week':
        return "Week's Overview";
      case 'month':
        return "Month's Overview";
      default:
        return "Overall Overview";
    }
  }

  toggleStatusFilter(status: string) {
    if (this.selectedStatus === status) {
      this.selectedStatus = '';
    } else {
      this.selectedStatus = status;
    }
    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }
    this.statusFilter$.next(this.selectedStatus);
  }

  fetchOverviewStats(param: any) {
    const countParam = {
      ...param
    };
    if (countParam.status) {
      delete countParam.status;
    }
    this.overviewStatsSubject.next(countParam);
  }

  toggleOverbookedFilter() {
    this.isFilteringOverbooked = !this.isFilteringOverbooked;
    if (this.isFilteringOverbooked) {
      this.selectedStatus = '';
    }
    if (this.paginator) {
      this.paginator.pageIndex = 0;
    }
    this.statusFilter$.next(this.selectedStatus);
  }

  getSlotLabel(slot: any): string {
    if (this.selected_tab === 'today' || this.selected_tab === 'tomorrow') {
      return slot.timeLabel;
    } else {
      const dateStr = moment(slot.date).format('DD MMM');
      return `${dateStr}, ${slot.timeLabel}`;
    }
  }

  openWalkInModal() {
    this.appointment = new Appointment();
    this.appointment.appointment_type = 'walk_in';
    this.appointment.appointment_source = 'walk_in';
    this.formAction = 'add';
    this.modalService.open(this.contentTemplate, { size: 'lg', scrollable: false });
  }

  openScheduleModal(content: any) {
    this.modalService.open(content, { size: 'xl', scrollable: true, centered: true, windowClass: 'modal-schedule-popup' });
  }

  openReportsModal(content: any) {
    this.modalService.open(content, { size: 'xl', scrollable: true, centered: true, windowClass: 'modal-reports-popup' });
  }

  openRemindersModal(content: any) {
    this.reminderFollowUp = false;
    this.reminderUpcoming = false;
    this.reminderSending = false;
    this.modalService.open(content, { size: 'md', scrollable: false, centered: true, windowClass: 'modal-reminders-popup' });
  }

  sendReminders(modal: any) {
    if (!this.reminderFollowUp && !this.reminderUpcoming) return;
    this.reminderSending = true;
    const types: string[] = [];
    if (this.reminderFollowUp) types.push('follow_up');
    if (this.reminderUpcoming) types.push('upcoming');
    // Simulate sending — replace with real API call e.g. this.api.sendReminders({ types })
    setTimeout(() => {
      this.reminderSending = false;
      this.toast.success(`Reminders sent to ${types.join(' & ')} patients`, 'Success');
      modal.dismiss();
    }, 1500);
  }

  getFollowUpPatients(): any[] {
    if (!this.dataSource?.data) return [];
    return this.dataSource.data.filter(item => {
      const type = (item.appointment?.check_in_type || '').toLowerCase();
      const appType = (item.appointment?.appointment_type || '').toLowerCase();
      return type.includes('follow-up') || type.includes('follow_up') || 
             appType.includes('follow_up') || appType.includes('follow-up');
    });
  }

  getUpcomingPatients(): any[] {
    if (!this.dataSource?.data) return [];
    const todayStr = moment().format('YYYY-MM-DD');
    const tomorrowStr = moment().add(1, 'day').format('YYYY-MM-DD');
    return this.dataSource.data.filter(item => {
      const d = item.appointment?.appointment_date ? moment(item.appointment.appointment_date).format('YYYY-MM-DD') : '';
      return d === todayStr || d === tomorrowStr;
    });
  }

  getSelectedPatients(): any[] {
    const list: any[] = [];
    const seenIds = new Set<any>();

    const addToList = (patients: any[]) => {
      patients.forEach(p => {
        const appId = p.appointment?.app_id;
        if (appId && !seenIds.has(appId)) {
          seenIds.add(appId);
          list.push(p);
        }
      });
    };

    if (this.reminderFollowUp) {
      addToList(this.getFollowUpPatients());
    }
    if (this.reminderUpcoming) {
      addToList(this.getUpcomingPatients());
    }
    return list;
  }

  getSelectedPatientsCount(): number {
    return this.getSelectedPatients().length;
  }

}
  
function observableOf(arg0: null): any {
  //throw new Error('Function not :mplemented.');
}

export class Appointment {
  app_id!: Number;
  user!:any;
  appointment_source:string = "webapp";
  appointment_type:string = "";
  appointment_date:string = "";
  appointment_time:string = "";
  status:string = "booked";
  user_id:string = "";
  patient_id:Number = 0;
  dept_id:string = "";
  client_id:string = ""
  check_in_type:string = "follow-up";
  opd_number:string = ""
  hospital_id:Number = 0
  center_id:Number = 0
}